const StripeCheckoutInlineEditor = () => {
  return <></>;
};

export default StripeCheckoutInlineEditor;
